// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [jwtToken, setJwtToken] = useState(localStorage.getItem('jwtToken'));
  const [isAuthenticated, setIsAuthenticated] = useState(!!jwtToken);

  useEffect(() => {
    setIsAuthenticated(!!jwtToken);
  }, [jwtToken]);

  const login = (token) => {
    localStorage.setItem('jwtToken', token);
    setJwtToken(token);
    window.location.href = '/new/apps'; // Redirect to the home page
  };

  const logout = () => {
    localStorage.removeItem('jwtToken');
    setJwtToken(null);
    window.location.href = '/'; // Redirect to the home page
  };

  return (
    <AuthContext.Provider value={{ jwtToken, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
